import React from "react";
import {
  FaPaperclip,
  FaFileImage,
  FaFilePdf,
  FaFileWord,
  FaFileExcel,
  FaFileZipper,
} from "react-icons/fa6";

const AttachmentItem = ({ file, emailUser, messageId }) => {
  const isImage = file.mimeType && file.mimeType.includes("image");
  const viewUrl = `${process.env.REACT_APP_CRM_API}gmail/attachment/${emailUser}?message_id=${messageId}&attachment_id=${file.attachmentId}&mime_type=${file.mimeType}`;

  const formatBytes = (bytes) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    const sizes = ["Bytes", "KB", "MB", "GB"];
    return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + " " + sizes[i];
  };

  const getFileIcon = (mimeType) => {
    if (!mimeType) return FaPaperclip;
    if (mimeType.includes("image")) return FaFileImage;
    if (mimeType.includes("pdf")) return FaFilePdf;
    if (
      mimeType.includes("word") ||
      mimeType.includes("officedocument.wordprocessingml")
    )
      return FaFileWord;
    if (
      mimeType.includes("excel") ||
      mimeType.includes("officedocument.spreadsheetml")
    )
      return FaFileExcel;
    if (mimeType.includes("zip") || mimeType.includes("compressed"))
      return FaFileZipper;
    return FaPaperclip;
  };

  const FileIcon = getFileIcon(file.mimeType);

  const openFileInNewTab = (e) => {
    if (e) e.preventDefault();
    window.open(viewUrl, "_blank");
  };

  return (
    <div className="attachment-card">
      <div className="attachment-left">
        <div
          className="attachment-icon-box clickable"
          onClick={openFileInNewTab}
        >
          <FileIcon />
        </div>
        <div className="attachment-info" onClick={openFileInNewTab}>
          <div className="attachment-name" title={file.name}>
            {file.name}
          </div>
          <div className="attachment-meta">
            {formatBytes(file.size || 0)} •{" "}
            {file.mimeType && file.mimeType.split("/")[1].toUpperCase()}
          </div>
        </div>
      </div>
    </div>
  );
};

function NotesAttatchment({ item }) {
  if (!item) return null;

  let attachments = [];
  if (item.email_attachments) {
    try {
      attachments =
        typeof item.email_attachments === "string"
          ? JSON.parse(item.email_attachments)
          : item.email_attachments;
    } catch (e) {
      console.error("Failed to parse attachments", e);
    }
  }

  if (attachments && attachments.length > 0) {
    const emailUser = item.inbox;
    const messageId = item.email_message_id || item.message_id;

    return (
      <div className="note-attachments">
        {attachments.map((file, idx) => (
          <AttachmentItem
            key={idx}
            file={file}
            emailUser={emailUser}
            messageId={messageId}
          />
        ))}
      </div>
    );
  }

  return null;
}

export default NotesAttatchment;
